export const yesNo = [
  { value: 'TRUE', label: 'Yes' },
  { value: 'FALSE', label: 'No' },
];
